export const InquiryServicesRequired = {
  Hotels: 'Hotels',
  Flights: 'Flights',
  Transfers: 'Transfers',
  Restaurants: 'Restaurants',
  CarRental: 'Car Rental',
  VipAirport: 'VIP Airport',
} as const;
export type InquiryServicesRequired = (typeof InquiryServicesRequired)[keyof typeof InquiryServicesRequired];
